import { ProductCartItem } from "features/cart/types";
import React from "react";
import styled from "styled-components/macro";
import { Mobile, TabletUp, device } from "theme/Breakpoints";
import { SecondaryPrice, MainPrice, smallShadow } from "theme/GlobalElements";
import climaIMG from "assets/images/clima_img.png";
import { colors } from "theme/Theme";
import { MdClose } from "react-icons/md";
import { useInstallation } from "hooks/useInstallation";
import { Product } from "features/ProductReel/types";
import DualPrice, { EuroPrice } from "components/Price";
import { toEuroNumber } from "features/utils";

interface AdminCartElementProps {
  item: ProductCartItem;
  removeItemHandler: any;
}

const AdminCartElement: React.FC<AdminCartElementProps> = ({
  item,
  removeItemHandler,
}) => {
  const { installationPrice, installationPriceEur } = useInstallation(
    item.product.power_btu,
    item.product.type
  );
  const displayPrice = item.product.price_promotion
    ? item.product.price_promotion + installationPrice
    : item.product.price + installationPrice;

  const removeItem = () => {
    if (item.product.refId) {
      removeItemHandler(item.product.refId);
    } else {
      removeItemHandler(item.product._id);
    }
  };

  return (
    <AdminCartElementContainer>
      {removeItemHandler && <StyledMdClose onClick={removeItem} />}
      <DesktopContainer>
        {item.product.images && Array.isArray(item.product.images) && (
          <ProductImage
            src={`data:${item.product.images[0].contentType};base64,${item.product.images[0].image}`}
          />
        )}
        {item.product.image && (
          <ProductImage
            src={`data:${item.product.image.contentType};base64,${item.product.image.image}`}
          />
        )}
        <TitleAndPrice>
          <Mobile>
            <span className="text-sm">{item.product.title}</span>
            <MobilePricesAndCounter>
              <Prices>
                {item.product.price_promotion && (
                  <SecondaryPrice className="text-sm">
                    <EuroPrice
                      bgn={item.product.price + installationPrice}
                      eur={toEuroNumber(item.product.price + installationPrice)}
                    />
                  </SecondaryPrice>
                )}
                <MainPrice className="text-body">
                  <DualPrice
                    bgn={displayPrice}
                    eur={toEuroNumber(displayPrice)}
                    showBgn
                  />
                </MainPrice>
              </Prices>
            </MobilePricesAndCounter>
          </Mobile>
          <TabletUp>
            <span className="text-body">{item.product.title}</span>
            <MobilePricesAndCounter>
              <Prices>
                {item.product.price_promotion && (
                  <SecondaryPrice className="text-sm">
                    <EuroPrice
                      bgn={item.product.price + installationPrice}
                      eur={toEuroNumber(item.product.price + installationPrice)}
                    />
                  </SecondaryPrice>
                )}
                <PricePlus>
                  <MainPrice className="text-md">
                    <DualPrice
                      bgn={displayPrice}
                      eur={toEuroNumber(displayPrice)}
                      showBgn
                    />
                  </MainPrice>
                  {item.installation && (
                    <Installation className="text-xs">
                      (Включен монтаж
                      <DualPrice
                        bgn={installationPrice}
                        eur={installationPriceEur}
                        showBgn
                      />)
                    </Installation>
                  )}
                </PricePlus>
              </Prices>
              <span className="text-md">Поръчани: {item.count}</span>
            </MobilePricesAndCounter>
          </TabletUp>
        </TitleAndPrice>
      </DesktopContainer>
    </AdminCartElementContainer>
  );
};

const AdminCartElementContainer = styled.div`
  position: relative;
  display: flex;
  flex-flow: column;
  padding: 12px;
  ${smallShadow}
  max-width: 1200px;
  width: 100%;
  & + & {
    margin: 12px 0;
  }
`;

const ProductImage = styled.img`
  width: 80px;
  height: 60px;
  @media only screen and (${device.tablet}) {
    width: 120px;
    height: 90px;
  }

  @media only screen and (${device.laptop}) {
    width: 180px;
    height: 135px;
  }
`;

const Prices = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-top: 5px;

  ${MainPrice} {
    order: 2;
  }

  ${SecondaryPrice} {
    order: 1;
    margin: 0;
  }

  @media only screen and (${device.laptop}) {
    margin-top: 10px;
  }
`;

const DesktopContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-around;
`;

const TitleAndPrice = styled.div`
  display: flex;
  flex-flow: column;
  align-self: stretch;

  @media only screen and (${device.laptop}) {
    flex-basis: 60%;
  }

  @media only screen and (${device.laptopL}) {
    flex-basis: 70%;
  }

  @media only screen and (${device.desktop}) {
    flex-basis: 80%;
  }
`;

const MobilePricesAndCounter = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: flex-end;
`;

const StyledMdClose = styled(MdClose)`
  position: absolute;
  top: 5px;
  right: 5px;
  width: 24px;
  height: 24px;
  color: ${colors.gray};
  transition: 0.3s all;

  &:hover {
    color: ${colors.red};
  }
`;
const PricePlus = styled.div`
  display: inline-flex;
  align-items: baseline;
  order: 2;
  ${MainPrice} {
    order: 0 !important;
    margin-right: 10px;
  }
`;

const Installation = styled.p`
  color: ${colors.lighter_blue};
  span {
    font-weight: bold;
  }
`;
export default AdminCartElement;
